/** Tablet tab bar floats over screen content — columns need this much bottom clearance so scrolled content isn't hidden behind it. */
export const TABLET_TAB_BAR_CLEARANCE = 70;
